import LzCrudModelInput from "./input";

/**
 * LzCrudModelListCol class
 */
export default class LzCrudModelListCol {

    constructor(model, field) {
        if (!model) {
            model = {};
        }
        if (!field) {
            field = { required: false, default: '' };
        }

        this.label = model.label ? model.label : '';
        this.icon = model.icon ? model.icon : '';
        this.alignment = model.alignment ? model.alignment : 'center';
        this.sortable = typeof model.sortable === 'boolean' ? model.sortable : false;
        this.displayFunction = LzCrudModelInput.getDisplayFunction(model, field);
        this.mediaParams = model.mediaParams;
        this.isMedia = !!model.mediaParams; // save as a class var instead of making a getter because later this.mediaParams could be initialized to something and then it will not remain null
    }

    static parseData(data, fields) {
        const out = {};

        if (!data) {
            return out;
        }

        const keys = Object.keys(data);
        for (const key of keys) {
            out[key] = new LzCrudModelListCol(data[key], fields ? fields[key] : null);
        }

        return out;
    }

}
